import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import classes from './CourseAditionalMaterial.module.css';

const CourseAditionalMaterial = props => {
  const { t } = useTranslation(['course']);
  const openFile = (url, path) => () => {
    window.open(`${path}`, '_blank');
  };

  return (
    <div
      className={
        props.accessCourse
          ? classes.productLearnInfoAccessSection
          : classes.productLearnInfoSection
      }
    >
      <h2 className={classes.includesTitle}>
        {t('aditional_files')}
      </h2>
      {props.aditionalMaterial && (
        <aside className={classes.productContentItemsContainer}>
          {props.aditionalMaterial.map(material => (
            <p
              key={material.idArchivoVideo}
              className={`${
                props.accessCourse ? classes.materialClick : ''
              }`}
              onClick={
                props.accessCourse &&
                openFile(material.isURL, material.path)
              }
            >
              <figure className={classes.productIcon}>
                <img
                  className={classes.img}
                  src="https://d1g6c01s9ssd7h.cloudfront.net/img/Documento_icon.png"
                />
              </figure>
              <span className={classes.productContentItemText}>
                {material.name}
              </span>
            </p>
          ))}
        </aside>
      )}
    </div>
  );
};

CourseAditionalMaterial.propTypes = {
  // eslint-disable-next-line react/require-default-props
  aditionalMaterial: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  accessCourse: PropTypes.bool
};

export default CourseAditionalMaterial;
